<template>
  <div
    v-click-outside="emitClose"
    class="periodpicker periodpicker-inline"
    data-walkthrough-id="dropdown-periodpicker"
    @click.prevent.stop="doNothing"
  >
    <PeriodPickerYearsWithPeriods
      v-if="showPeriodsWithYears"
      :current-ledger-id="currentLedgerId"
      :highlighted-period="highlightedPeriod"
      :highlighted-year="highlightedYear"
      :ledgers-per-year="ledgersPerYear"
      :years="years"
      @period-click="openPeriod"
    />
    <PeriodPickerYears
      v-else
      :years="years"
      :highlighted-year="highlightedYear"
      @yearClick="openYear"
    />
  </div>
</template>

<script>
import PeriodPickerYearsWithPeriods from './period-picker-years-with-periods'
import PeriodPickerYears from './period-picker-years'

export default {
  components: {
    PeriodPickerYearsWithPeriods,
    PeriodPickerYears,
  },
  props: {
    years: {
      type: Array,
      required: true,
    },
    ledgersPerYear: {
      type: Number,
      default: 12,
    },
    currentLedgerId: {
      type: Number,
      required: true,
    },
  },
  emits: ['change-compare-period', 'close-period-picker'],
  computed: {
    allPeriods() {
      return this.years.flatMap((year) => year.periods)
    },
    highlightedPeriod() {
      return this.allPeriods.find(
        (period) => this.currentLedgerId === period.ledgerId
      )
    },
    highlightedYear() {
      return this.years.find(
        (year) =>
          year.periods.find(
            (period) => period.ledgerId === this.currentLedgerId
          ) !== undefined
      )
    },
    showPeriodsWithYears() {
      return this.ledgersPerYear !== 1
    },
  },
  methods: {
    doNothing() {
      // intentionally left blank
    },
    triggerChangePeriod(ledgerId) {
      this.$emit('change-compare-period', ledgerId)
    },
    openPeriod({ period }) {
      this.triggerChangePeriod(period.ledgerId)
    },
    openYear({ year }) {
      if (year.periods.length) {
        this.triggerChangePeriod(year.periods[0].ledgerId)
      }
    },
    emitClose() {
      this.$emit('close-period-picker')
    },
  },
}
</script>
